import React from "react";
import { Row, Col, Button, Form, Tabs, Tab } from "@themesberg/react-bootstrap";
import { SpinnerLoader } from "../../../../../components/Preloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import { DateRangePickerWithoutInput } from "../../../../../components/DateRangePicker";
import useKPISummary from "../../hooks/useKPISummary";
import { downloadFile } from "../../../../../utils/fileDownloader";
import KPISummaryTable from "../../../../../components/KPISummaryTable";
import DateOptionsFilter from "../../../../../components/DateOptionsFilter";
import PaginationComponent from "../../../../../components/Pagination";

export default ({ selectedPortal, selectedClient }) => {
  const {
    loadKPISummary,
    loading,
    setState,
    state,
    getCsvDownloadUrl,
    KPISummary,
    selectedTab,
    setSelectedTab,
    search,
    setSearch,
    dateOptions,
    setDateOptions,
    limit,
    setLimit,
    page,
    setPage,
    totalPages,
    handleResetFilters,
  } = useKPISummary({ selectedPortal, selectedClient });
console.log({KPISummary} , "KPISummaryKPISummary")
  return (
    <>

      <Row className="align-items-center mb-3 flex-md-row flex-column">

        <Col xs={12} lg={3} className="mb-2 mb-md-0">
          <h3 className="d-flex mb-0">
            Bonus Report{" "}
            {loading ? (
              <SpinnerLoader />
            ) : (
              <FontAwesomeIcon
                onClick={handleResetFilters}
                style={{
                  fontSize: "15px",
                  color: "gray",
                  cursor: "pointer",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
                icon={faRedo}
              />
            )}
          </h3>
        </Col>


        <Col xs={12} lg={9}>
          <div className="d-flex flex-column flex-md-row justify-content-md-end align-items-md-center gap-2">
            <Form.Control
              type="search"
              placeholder="Search Player"
              size="sm"
              value={search}
              // style={{ maxWidth: "300px" }}
              onChange={(event) => setSearch(event.target.value)}
              className="me-md-2"
            />

            <div className="d-flex flex-column flex-md-row align-items-md-center">
              <Form.Label className="mb-1 mb-md-0 me-md-2">Date Options</Form.Label>
              <DateOptionsFilter
                dateOptions={dateOptions}
                setDateOptions={setDateOptions}
              />
            </div>

            <Button
              variant="outline-success"
              size="sm"
              style={{ width: "150px" }}
              disabled={KPISummary?.length < 1}
              onClick={() => downloadFile(getCsvDownloadUrl())}
            >
              Export Details
            </Button>
          </div>
        </Col>
      </Row>


      {/* <Tabs
        activeKey={selectedTab}
        onSelect={(tab) => setSelectedTab(tab)}
        className='nav-light dashboard'
      >
        <Tab eventKey='banking' title='BANKING'>
          <div className='mt-2'>
            <Row className='mt-3 d-flex flex-row-reverse text-right'>
            <KPISummaryTable KPISummary={KPISummary} />
            </Row>
          </div>
        </Tab>

        <Tab eventKey='casino' title='CASINO'>
          <div className='mt-2'>
            <Row className='mt-3 d-flex flex-row-reverse text-right'>
            <KPISummaryTable KPISummary={KPISummary} />
            </Row>
          </div>
        </Tab>
      </Tabs> */}

      <KPISummaryTable KPISummary={KPISummary?.data} />
      {KPISummary?.count !== 0 && !loading && (
        <PaginationComponent
          page={KPISummary?.count < page ? setPage(1) : page}
          totalPages={totalPages}
          setPage={setPage}
          limit={limit}
          dontShowRow={false}
          setLimit={setLimit}
        />
      )}
    </>
  );
};
